import Vue from 'vue'
import i18n from './i18n'
import './plugins/axios'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import VueQrcodeReader from "vue-qrcode-reader";
import VueQrcode from '@chenfengyuan/vue-qrcode';
import VueSweetalert2 from 'vue-sweetalert2';
import VueFriendlyIframe from 'vue-friendly-iframe';
import ReadMore from 'vue-read-more';
import './registerServiceWorker'


Vue.component('vue-friendly-iframe', VueFriendlyIframe);
Vue.component(VueQrcode.name, VueQrcode);
Vue.use(VueQrcodeReader);
Vue.use(VueSweetalert2);
Vue.use(ReadMore);
Vue.config.productionTip = false;


//Load token saved
const token = localStorage.getItem('token')
if (token) {
    Vue.axios.defaults.headers.common['Authorization'] = token
}
//Loads language saved in previous session
const lang = localStorage.getItem('lang') || 'es'
i18n.locale = lang

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app');
